<template>
    <v-date-picker
        class="vx-calendar-Icon"
        v-model="localValue"
        :is-dark="isThemeDark"
        :popover="{ placement, visibility: 'hover' }"
        :mode="calendarMode"
    >
        <vx-action-icon
            icon="CalendarIcon"
            hover-icon="XIcon"
            hover-color="danger"
            active-color="primary"
            :active="value && !!value.start"
            tooltip="Clear"
            @click="localValue = null"
        ></vx-action-icon>
    </v-date-picker>
</template>

<script>
import VDatePicker from 'v-calendar/lib/components/date-picker.umd'
import ClickOutside from 'vue-click-outside'
import { mapGetters } from 'vuex'

export default {
    name: 'vx-calendar-icon',
    components: {
        VDatePicker
    },
    props: {
        value: {
            type: [Date, Object],
            default: () => {}
        },
        placement: {
            type: String,
            default: 'bottom'
        },
        attributes: {
            type: Array,
            default: () => []
        },
        disabledDates: {
            type: Array,
            default: () => []
        },
        range: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            focused: false,
            valid: false
        }
    },
    watch: {},
    computed: {
        ...mapGetters({
            isThemeDark: 'user/isThemeDark'
        }),
        localValue: {
            get() {
                return this.value
            },
            set(val) {
                if (
                    val == null &&
                    this.localValue &&
                    (this.localValue.start == null || this.localValue.end == null)
                ) {
                    // prevent the wrapped component from removing a half filled date range
                    return
                }
                this.$emit('input', val)
            }
        },
        calendarMode() {
            return this.range ? 'range' : 'single'
        }
    },
    methods: {
        deFocus(e) {
            this.focused = false
        },
        onInputFocused() {
            this.focused = true
            this.$nextTick(() => {
                this.$refs.calendar.focusDate(this.value)
            })
        },
        tabNext(e) {
            this.focused = false
            this.$nextTick(() => {
                var next = this.$refs.input.$el.nextFormField()
                if (next) {
                    next.focus()
                }
            })
        },
        tabBack(e) {
            this.focused = false
            this.$nextTick(() => {
                var prev = this.$refs.input.$el.previousFormField()
                if (prev) {
                    prev.focus()
                }
            })
        }
    },
    directives: {
        ClickOutside
    }
}
</script>

<style scoped>
.vx-calendar-Icon ::v-deep .vc-popover-content-wrapper {
    position: absolute;
    z-index: 500000 !important;
    border-radius: 8px;
    margin-top: 4px;
}

.vx-calendar-Icon ::v-deep .vc-popover-content {
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
}

.vs-input.active ::v-deep label {
    color: rgba(var(--vs-primary), 1);
}

.vs-input.active ::v-deep input {
    border: 1px solid rgba(var(--vs-primary), 1) !important;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
}

.vs-input.active ::v-deep i {
    color: rgba(var(--vs-primary), 1);
}
</style>
